export default __webpack_public_path__ + "static/media/b0bdbcef3046fe9549b7fddcfc2a2ff11637350506913.aa7fb035.webp";